import { ROLES } from "containers/ScopeContext/roles.enum";
import { t } from "i18next";

export const getUserRolesLabel = (role: ROLES) => {
    const labels = {
        [ROLES.NONE]: t("Members.None"),
        [ROLES.OWNER]: t("Members.Publisher"),
        [ROLES.RIGHTS_MANAGER]: t("Members.RightsManager"),
        [ROLES.STOCK_MANAGER]: t("Members.StockManager"),
        [ROLES.ACCOUNTANT]: t("Members.Accountant"),
        [ROLES.VIEW_ONLY]: t("Members.ViewOnly"),
        [ROLES.AGREEMENT_ADMIN]: t("Members.AgreementAdmin"),
        [ROLES.AGREEMENT_MANAGER]: t("Members.AgreementManager"),
        [ROLES.AGREEMENT_CONTRIBUTOR]: t("Members.AgreementContributor"),
    };

    return labels[role] ?? role;
};

export const getUserRoleDescription = (role: ROLES) => {
    const descriptions = {
        [ROLES.NONE]: t("Members.NoneDescription"),
        [ROLES.OWNER]: t("Members.OwnerDescription"),
        [ROLES.RIGHTS_MANAGER]: t("Members.RightsManagerDescription"),
        [ROLES.STOCK_MANAGER]: t("Members.StockManagerDescription"),
        [ROLES.ACCOUNTANT]: t("Members.AccountantDescription"),
        [ROLES.VIEW_ONLY]: t("Members.ViewOnlyDescription"),
        [ROLES.AGREEMENT_ADMIN]: t("Members.AgreementAdminDescription"),
        [ROLES.AGREEMENT_MANAGER]: t("Members.AgreementManagerDescription"),
        [ROLES.AGREEMENT_CONTRIBUTOR]: t("Members.AgreementContributorDescription"),
    };

    return descriptions[role] ?? "";
};
